// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { hyperlinkPlugin } from '@atlaskit/editor-plugin-hyperlink';
export type {
	HyperlinkPlugin,
	HyperlinkPluginOptions,
	HyperlinkPluginDependencies,
	HyperlinkPluginActions,
	HyperlinkPluginSharedState,
	HideLinkToolbar,
	ShowLinkToolbar,
	InsertLink,
	UpdateLink,
} from '@atlaskit/editor-plugin-hyperlink';
